import { MAX_OUTPUT_WIDTH, MIN_OUTPUT_WIDTH } from '../constants'
import { CreationToolFrame, CreationToolSourceFile } from '../types'
import getSourceInfo from './get-source-info'

const preloadImage = (url: string): Promise<HTMLImageElement> =>
    new Promise((resolve, reject) => {
        const img = document.createElement('img')
        img.onload = () => {
            resolve(img)
        }
        img.onerror = error => {
            reject(error)
        }
        img.src = url
    })

const drawToCanvas = (img: HTMLImageElement | HTMLCanvasElement): HTMLCanvasElement => {
    const canvas = document.createElement('canvas')
    const context = canvas.getContext('2d')
    canvas.width = Math.max(Math.min(img.width, MAX_OUTPUT_WIDTH), MIN_OUTPUT_WIDTH)
    canvas.height = canvas.width / (img.width / img.height)
    context?.drawImage(img, 0, 0, canvas.width, canvas.height)
    return canvas
}

/**
 * Processes any file or url and returns the file's canvas frames. (if not a video)
 * @param source
 */
const getProcessedSource = async (source: File | string): Promise<CreationToolSourceFile> => {
    const { isUrl, isAnimated } = getSourceInfo(source)
    let frames: CreationToolFrame[] = []
    let width = 0
    let height = 0

    if (!isAnimated) {
        const fileUrl = !isUrl ? URL.createObjectURL(source as File) : null
        const img = await preloadImage(fileUrl || (source as string))
        const canvas = drawToCanvas(img)
        frames = [{ canvas }]
        width = canvas.width
        height = canvas.height

        if (fileUrl) {
            URL.revokeObjectURL(fileUrl)
        }
    }

    return {
        source,
        frames,
        width,
        height,
    }
}

export default getProcessedSource
